module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-button__multiple no-print"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212,
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
    }],
    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
    attrs: {
      "content": _vm.tooltipArrowLeft
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "no-print do-button__multiple__bttn",
    class: {
      'bttn--disabled': _vm.isToday
    },
    on: {
      "click": function($event) {
        return _vm.$emit('today')
      }
    }
  }, [_vm._v("\n    I dag\n  ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212,
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n             }"
    }],
    staticClass: "do-button__multiple__bttn icon-arrow-right4",
    attrs: {
      "content": _vm.tooltipArrowRight
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-117f370b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/DutyScheduleNav.vue
// module id = 1764
// module chunks = 1